import * as React from 'react';
import { User } from 'oidc-client';
import { AnyAction } from 'redux';
import styled from 'styled-components';
import ContentConstants from '../../../contentConstants';
import { DistributionType, IParticipationCountsVm } from '../../../models';
import { HubConnectionName } from '../../../models/HubConnectionName';
import { ActionTypes } from '../../../store/ActionTypes';
import { CardLayout } from '../../common';
import { ParticipationMonitorChart, ParticipationMonitorTable } from './participation-monitor';

export interface IParticipationMonitorProps {
	audienceId: number;
	distributionType?: DistributionType;
	isLoadingAudiences: boolean;
	isLoadingParticipationCounts: boolean;
	participationCounts?: IParticipationCountsVm;
	surveyId: number;
	user?: User;
	ConnectToSignalR: (user: User, hubConnectionName: HubConnectionName, dispatchType: AnyAction) => void;
	DisconnectSignalR: (hubConnectionName: HubConnectionName) => void;
	GetParticipationCounts: (surveyId: number, audienceId: number) => void;
}

interface IParticipationMonitorState {
	includePartialCompletes: boolean;
}

const MonitorContentWrapper = styled.div`
	display: flex;
	align-items: center;
`;

export class ParticipationMonitor extends React.PureComponent<IParticipationMonitorProps, IParticipationMonitorState> {
	constructor(props: IParticipationMonitorProps) {
		super(props);

		this.state = { includePartialCompletes: false };

		this.toggleIncludePartialCompletes = this.toggleIncludePartialCompletes.bind(this);
	}

	public UNSAFE_componentWillMount() {
		if (this.props.audienceId !== 0) {
			this.props.GetParticipationCounts(this.props.surveyId, this.props.audienceId);
		}
		this.props.ConnectToSignalR(this.props.user!, HubConnectionName.SurveyParticipantCountsChange, {
			type: ActionTypes.SIGNALR_PARTICPANT_MONITOR_COUNTS_CHANGED,
			payload: '',
		});
	}

	public componentWillUnmount() {
		this.props.DisconnectSignalR(HubConnectionName.SurveyParticipantCountsChange);
	}

	public UNSAFE_componentWillReceiveProps(nextProps: IParticipationMonitorProps) {
		if (nextProps.audienceId !== this.props.audienceId) {
			this.props.GetParticipationCounts(nextProps.surveyId, nextProps.audienceId);
		}
	}

	public toggleIncludePartialCompletes() {
		const includePartialCompletes = !this.state.includePartialCompletes;
		this.setState({ includePartialCompletes });
		return includePartialCompletes;
	}

	public render() {
		const { isLoadingAudiences, isLoadingParticipationCounts, participationCounts, distributionType } = this.props;
		const { includePartialCompletes } = this.state;

		return (
			<CardLayout
				loading={isLoadingAudiences || isLoadingParticipationCounts}
				title={ContentConstants.SURVEY_ADMIN_ACTION_PARTICIPATION_MONITOR}
			>
				{participationCounts && (
					<MonitorContentWrapper>
						{this.getChart(participationCounts, includePartialCompletes, distributionType)}
						<ParticipationMonitorTable
							participationCounts={participationCounts}
							distributionType={distributionType!}
							includePartialCompletes={includePartialCompletes}
							toggleIncludePartialCompletes={this.toggleIncludePartialCompletes}
						/>
					</MonitorContentWrapper>
				)}
			</CardLayout>
		);
	}

	public getChart(participationCounts: IParticipationCountsVm, includePartialCompletes: boolean, distributionType?: DistributionType) {
		if (distributionType !== DistributionType.SingleLinkWithoutDistribution && distributionType !== DistributionType.GroupBasedLinks) {
			return <ParticipationMonitorChart participationCounts={participationCounts} includePartialCompletes={includePartialCompletes} />;
		}
	}
}
